import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBookSimple: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="book-simple, guide, info, faq"><path fillRule="evenodd" clipRule="evenodd" d="M6.75 2C5.23122 2 4 3.23122 4 4.75V19.25C4 20.7688 5.23122 22 6.75 22H19.25C19.6642 22 20 21.6642 20 21.25V2.75C20 2.33579 19.6642 2 19.25 2H6.75ZM5.5 19V19.25C5.5 19.9404 6.05964 20.5 6.75 20.5H18.5V17.5H7C6.17157 17.5 5.5 18.1716 5.5 19Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBookSimple;
